module.exports = __webpack_public_path__ + "img/loading-quote-img-6.c6deea19.png";